export default "__VITE_PUBLIC_ASSET__26cc9c44__"